import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

// Standard-surface-owned card compatibility row.

export function LegacyCardTemplate({ controls, slots }: SubTemplateProps) {
  return (
    <>
      <div className="md-legacy-card-row clear-both min-h-[98px] border-b border-[#e6e6e6] bg-white py-3 pl-[18px] pr-2.5 text-black text-[13px] font-[Arial,Tahoma,Verdana,sans-serif] [&_.md-sub-icon]:float-left [&_.md-sub-icon]:mb-1 [&_.md-sub-icon]:mr-1 [&_.md-sub-text]:ml-2.5 [&_.md-sub-text]:mt-2">
        {controls.iconStrip}
        <div className="md-legacy-card-title mt-2 block min-h-6 [&_.md-sub-title-link]:text-black">
          {controls.header}
        </div>
        {controls.text}
        {controls.meta}
      </div>
      {slots.allChildren}
    </>
  )
}
